import mapper from "./mapper"

export const authenticationMapper = mapper

export default mapper
